<template>
  <div class="rescue global-rescue">
    <BackTop></BackTop>
    <div class="main">
      <Breadcrumb class="bread rescueBread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/rescue">全球救援</BreadcrumbItem>
        <BreadcrumbItem class="bread-last">境外紧急救援服务</BreadcrumbItem>
      </Breadcrumb>
      <h3 class="rescue-bigtitle"
          style="margin-bottom:39px;">境外紧急救援服务 </h3>
      <h4 class="rescue-title">为何选择威马捷的境外救援服务</h4>
      <div class="experience-part">
        <img :src="overseas2"
             class="img-style"
             alt=""
             style="width:900px;">
      </div>
      <h4 class="rescue-title">威马捷全球合作网络</h4>
      <div class="experience-part">
        <img :src="overseas3"
             alt=""
             style="width:928px;">
      </div>
      <!-- <ul class="overseas-list">
        <li>24H×365天提供服务的救援呼叫中心。</li>
        <li>广泛的全球合作网络</li>
        <li>丰富的医疗转运经验</li>
        <li>合理・严正的理赔审核体制</li>
      </ul> -->
      <h4 class="rescue-title">医疗救援服务图解</h4>
      <div class="experience-part">
        <img :src="overseasservice"
             alt=""
             style="width:928px;">
      </div>
      <h4 class="rescue-title">境外紧急救援服务内容</h4>
      <div class="personalized-list">
        <div class="personal-cell"
             v-for="(content,index) in contents"
             :key="index">
          <h5>{{content.title}}</h5>
          <p>{{content.info}}</p>
        </div>
      </div>
      <a class="more-cases"
         @click="toGuide">&nbsp;&nbsp;医疗救援服务案例>></a>
    </div>
  </div>
</template>
<script>
import overseasservice from '@/assets/images/rescue/overseas-service.jpg'

import overseas2 from '@/assets/images/rescue/overseas-service2.jpg'
import overseas3 from '@/assets/images/rescue/overseas-service3.png'
export default {
  data () {
    return {
      overseasservice, overseas2, overseas3,
      contents: [
        { title: '介绍医院及安排就医', info: '为境外客户介绍并安排最适合的医疗机构就诊。' },
        { title: '翻译服务', info: '为客户提供医疗翻译服务，协助当地医护人员的无障碍有效沟通。' },
        { title: '治疗监护', info: '客户住院期间，由威马捷顾问医生与当地主治医生取得联系，把握患者治疗情况。' },
        { title: '当地治疗评价及建议', info: '根据客户需求，由威马捷顾问医生就当地治疗情况作出医疗专业解析，并给出建议。' },
        { title: '紧急医疗转运', info: '如果当地医疗环境无法为客户提供所需治疗，为患者提供紧急转运，重伤患者将会根据情况安排患者在医护人员陪同下转运回国。' },
        { title: '遗体处理及转运', info: '客户在境外不幸身故时，威马捷会协助客户进行遗体处理手续，并可以应客户需求安排遗体转运回国。' },
        { title: '亲属紧急探访协助', info: '客户住院期间，为家属紧急前往境外事故地提供出行建议，及旅行救援。' },
        { title: '代垫医疗费及保险理赔手续', info: '在保险公司授权的情况下为客户代付治疗费，并协助客户取得理赔材料完成保险理赔手续。' },
        { title: '治疗费用管理', info: '通过威马捷的医疗网络，针对客户的高额治疗费用进行折扣申请，为客户及保险公司控制成本。' },
      ]
    }
  },
  mounted () {

  },
  methods: {
    toGuide () {
      localStorage.setItem('linkId', 'one')
      this.$router.push({
        path: '/rescueOfCustomerService'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.img-style {
  display: block;
  margin: auto;
}
.experience-part {
  border: none;
  padding: 0;
  margin-bottom: 76px;
}
.personal-cell {
  width: 302px;
  height: 240px;
  border: 1px solid #e9ebf4;
  padding: 0;
  margin-bottom: 30px;
  h5 {
    font-size: 20px;
    color: #33312f;
    height: 60px;
    line-height: 60px;
    background: #e9ebf3;
    padding-left: 11px;
    margin-bottom: 0;
  }
  p {
    font-size: 16px;
    color: #33312f;
    line-height: 16px;
    line-height: 32px;
    padding: 18px 11px;
  }
}
.overseas-list {
  margin-left: 38px;
  li {
    list-style: disc;
    list-style-position: inside;
    font-size: 24px;
    color: #333130;
    line-height: 36px;
  }
}
.personalized-list {
  display: flex;
  width: 928px;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}
.more-cases {
  display: inline-block;
  width: 217px;
  height: 38px;
  line-height: 38px;
  background: url('../assets/images/home/head-vip.jpg') no-repeat right;
  color: #fff;
  font-size: 20px;
  margin-bottom: 100px;
  cursor: pointer;
}
</style>